import React, { useEffect, useState } from 'react';
import { TextField, MenuItem } from '@mui/material';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

// Exams (Opener / Mid-Term / End-Term…) defined for a year · term · stage.
// Empty until all three are chosen, and for schools that haven't set up exams.
export function useTermExams(academicYear, term, stageCode) {
  const [exams, setExams] = useState([]);
  useEffect(() => {
    if (!academicYear || !term || !stageCode) { setExams([]); return; }
    let live = true;
    axios.get(
      `${API}/api/academics/assessment-exams?academicYear=${encodeURIComponent(academicYear)}&term=${term}&stageCode=${encodeURIComponent(stageCode)}`,
      { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
    ).then(r => { if (live) setExams(r.data || []); }).catch(() => { if (live) setExams([]); });
    return () => { live = false; };
  }, [academicYear, term, stageCode]);
  return exams;
}

// The exam id to send to the report endpoints. Reports are always per exam
// (Opener, End-Term… never mixed): an unset/stale choice falls back to the first
// exam. undefined only when the term has no exams (legacy flat setups).
export const examParam = (exams, value) => (
  exams.some(e => e._id === value) ? value : exams[0]?._id
);

// Report filter: one specific exam. Renders nothing when the term has no exams, so
// existing flat setups look exactly as before.
export default function ExamSelect({ exams, value, onChange, sx }) {
  const current = examParam(exams, value);
  useEffect(() => { if (current && current !== value) onChange(current); }, [current, value]); // eslint-disable-line
  if (!exams.length) return null;
  return (
    <TextField select size="small" label="Exam" sx={{ minWidth: 190, ...sx }}
      value={current || ''} onChange={e => onChange(e.target.value)}>
      {exams.map(e => <MenuItem key={e._id} value={e._id}>{e.name}</MenuItem>)}
    </TextField>
  );
}
